/**
 * UPLOAD-PHOTO-MODAL
 * Upload a photo for desktop or tablet
 */
import isTablet from "@/utils/is-tablet.utils"
import Modal from "./modal"
import { useEffect, useRef, useState } from "react"
import UploadButtonWidget from "@/widgets/upload-button.widget"
import fileToImage from "@/utils/file-to-image"
import { v4 as uuid } from "uuid"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { upload } from "@/redux/_upload.actions"
import LoadingModal from "@/modals/loading.modal"
import physicalRiskStore from "@/entities/physical-risk/model/physical-risk.store"
import Link from "./link"
import ModalConfirm from "./modal-confirm"

interface Props {
  onClose: () => void
  onUpload: (photoId: string) => void
}

export default function UploadPhotoModal(props: Props) {
  const dispatch = useAppDispatch()
  const isT = isTablet()

  //Selector
  const draftRisk = useAppSelector(physicalRiskStore.selectors.draft)

  //Ref
  const inputRef = useRef<HTMLInputElement | null>(null)

  //State
  const [modal, setModal] = useState<"MODAL_LOADING" | "MODAL_REMOVE" | null>(null)
  const [photoId] = useState(draftRisk.photoId)

  //Detect que je passe sur le mode photo
  useEffect(() => {
    if (isT) {
      inputRef.current?.click()
    }
  }, [isT])

  function handleCameraChange(e: React.ChangeEvent<HTMLInputElement>) {
    const files = Array.from(e.target.files || [])

    // Repasser en fullscreen
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch(() => {})
    }

    handleUpload(files)
    e.target.value = ""
  }

  async function handleRemove() {
    setModal("MODAL_LOADING")
    await dispatch(physicalRiskStore.thunks.updatePhoto(null))
    props.onClose()
  }

  async function handleUpload(files: File[]) {
    if (!files.length) return

    const id = uuid()
    const image = await fileToImage(files[0])
    setModal("MODAL_LOADING")
    const response: any = await dispatch(upload(id, image, "Photos", "image/png"))

    if (response === "OK") {
      props.onUpload(id)
    } else {
      props.onClose()
    }
  }

  return (
    <Modal onClose={() => props.onClose()} title="Importer une photo" isCloseButtonVisible isLarge>
      {modal === "MODAL_LOADING" && <LoadingModal />}
      {modal === "MODAL_REMOVE" && (
        <ModalConfirm onNo={() => setModal(null)} onYes={() => handleRemove()} textBold="Souhaitez-vous continuer ?" />
      )}
      {photoId && draftRisk.EstablishmentId && (
        <Link isWithoutMargin onClick={() => setModal("MODAL_REMOVE")}>
          Supprimer la photo existante
        </Link>
      )}
      {isT ? (
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          capture="environment"
          style={{ display: "none" }}
          onChange={handleCameraChange}
        />
      ) : (
        <div className="-m-[3px] mt-20">
          <UploadButtonWidget acceptedFiles="image/*" onUpload={(e) => handleUpload(e)} />
        </div>
      )}
    </Modal>
  )
}
